import { GraphQLFormattedError } from 'graphql';
import { VissErrorCode } from '../../types/viss/errors';
import { ProductType } from '../../types/viss/queries';

const NON_CRITICAL_VISS_ERRORS_FOR_CONFIGURATION = [
  VissErrorCode.BBD_INVALID_REQUEST,
  VissErrorCode.BBD_NOT_AVAILABLE,
  VissErrorCode.BBD_OTHER,
  VissErrorCode.SIM_SEARCH_INVALID_REQUEST,
  VissErrorCode.SIM_SEARCH_NOT_AVAILABLE,
  VissErrorCode.SIM_SEARCH_INSUFFICIENT_RESULT_DATA,
  VissErrorCode.SIM_SEARCH_NO_VEHICLES_FOR_MARKET,
  VissErrorCode.SIM_SEARCH_VEHICLE_NOT_FOUND,
  VissErrorCode.SIM_SEARCH_OTHER,
  VissErrorCode.HVD_INVALID_REQUEST,
];

const NON_CRITICAL_VISS_ERRORS_FOR_STOCK = [
  VissErrorCode.BBD_INVALID_REQUEST,
  VissErrorCode.BBD_NOT_AVAILABLE,
  VissErrorCode.BBD_OTHER,
  VissErrorCode.SIM_SEARCH_INVALID_REQUEST,
  VissErrorCode.SIM_SEARCH_NOT_AVAILABLE,
  VissErrorCode.SIM_SEARCH_OTHER,
  VissErrorCode.SIM_SEARCH_INSUFFICIENT_RESULT_DATA,
  VissErrorCode.SIM_SEARCH_NO_VEHICLES_FOR_MARKET,
  VissErrorCode.SIM_SEARCH_VEHICLE_NOT_FOUND,
  VissErrorCode.ISS_INVALID_REQUEST,
  VissErrorCode.ISS_NOT_AVAILABLE,
  VissErrorCode.ISS_OTHER,
];

export const hasCriticalError = (
  errors?: readonly GraphQLFormattedError[],
  productType: ProductType = 'CONFIGURATION',
): boolean =>
  productType === 'CONFIGURATION'
    ? Boolean(errors?.some(isCriticalConfigurationVehicleError))
    : Boolean(errors?.some(isCriticalStockVehicleError));

//filter out all errors that are non-critical for configurations
const isCriticalConfigurationVehicleError = (error: GraphQLFormattedError): boolean =>
  !NON_CRITICAL_VISS_ERRORS_FOR_CONFIGURATION.some((vissErrorCode) => vissErrorCode === error.extensions?.code);

//filter out all errors that are non-critical for stocks
const isCriticalStockVehicleError = (error: GraphQLFormattedError): boolean => {
  const errorIsInNonCriticalErrors = NON_CRITICAL_VISS_ERRORS_FOR_STOCK.some(
    (vissErrorCode) => vissErrorCode === error.extensions?.code,
  );
  const errorIsRelatedToBadges = Boolean(error.path?.includes('badges'));
  const errorIsNonCritical = errorIsInNonCriticalErrors || errorIsRelatedToBadges;
  const errorIsCritical = !errorIsNonCritical;
  return errorIsCritical;
};
